import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6afe178c")

_pushScopeId("data-v-6afe178c")
const _hoisted_1 = { class: "signin" }
const _hoisted_2 = { class: "main__section" }
const _hoisted_3 = { class: "title -bold" }
const _hoisted_4 = { class: "-regular" }
const _hoisted_5 = /*#__PURE__*/_createVNode("br", { class: "-pc" }, null, -1)
const _hoisted_6 = { class: "input-field" }
const _hoisted_7 = {
  for: "username",
  class: "-invisibility"
}
const _hoisted_8 = { class: "input-field" }
const _hoisted_9 = {
  for: "password",
  class: "-invisibility"
}
const _hoisted_10 = { class: "input-box__action" }
const _hoisted_11 = { class: "input-box__options" }
const _hoisted_12 = { class: "remember" }
const _hoisted_13 = {
  for: "rememberMe",
  class: "-bold"
}
const _hoisted_14 = { class: "siginup-wrapped -medium" }
const _hoisted_15 = { class: "siginup-locale" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Alert = _resolveComponent("Alert")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_Button = _resolveComponent("Button")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Specifications = _resolveComponent("Specifications")
  const _component_SelectLanguage = _resolveComponent("SelectLanguage")
  const _component_ViewProgressSpinner = _resolveComponent("ViewProgressSpinner")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("section", _hoisted_2, [
      (!!_ctx.alert.content)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            alert: _ctx.alert,
            "onUpdate:alert": _cache[1] || (_cache[1] = ($event: any) => (_ctx.alert = $event)),
            isConfirm: true,
            "onUpdate:clear": _cache[2] || (_cache[2] = 
          () => {
            _ctx.alert.content = '';
          }
        )
          }, null, 8, ["alert"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Form, {
        class: "input-box",
        onSubmit: _ctx.login
      }, {
        default: _withId(({ errors }) => [
          _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.t("Sign in")), 1),
          _createVNode("p", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.t("sign-in-titl-1")), 1),
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.t("sign-in-titl-2")), 1)
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_Field, {
              modelValue: _ctx.value.username,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.value.username = $event)),
              name: "username",
              rules: "required|email"
            }, {
              default: _withId(({ field }) => [
                _createVNode("label", _hoisted_7, _toDisplayString(_ctx.t("email")), 1),
                _createVNode(_component_InputText, _mergeProps({
                  id: "username",
                  type: "text",
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => (field.value = $event)
                }, field, {
                  class: { 'p-invalid': errors.username },
                  placeholder: _ctx.t('input-email'),
                  "aria-placeholder": _ctx.t('input-email')
                }), null, 16, ["modelValue", "onUpdate:modelValue", "class", "placeholder", "aria-placeholder"])
              ]),
              _: 2
            }, 1032, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              name: "username",
              class: "p-error"
            })
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_Field, {
              modelValue: _ctx.value.password,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.value.password = $event)),
              name: "password",
              rules: "required|password"
            }, {
              default: _withId(({ field }) => [
                _createVNode("label", _hoisted_9, _toDisplayString(_ctx.t("password")), 1),
                _createVNode(_component_InputText, _mergeProps({
                  id: "password",
                  type: "password",
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => (field.value = $event)
                }, field, {
                  class: { 'p-invalid': errors.password },
                  placeholder: _ctx.t('input-password'),
                  "aria-placeholder": _ctx.t('input-password')
                }), null, 16, ["modelValue", "onUpdate:modelValue", "class", "placeholder", "aria-placeholder"])
              ]),
              _: 2
            }, 1032, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              name: "password",
              class: "p-error"
            })
          ]),
          _createVNode("span", _hoisted_10, [
            _createVNode(_component_Button, {
              class: "-button -royalBlue",
              type: "submit"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t("signin")), 1)
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_Checkbox, {
                id: "rememberMe",
                modelValue: _ctx.isRemember,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isRemember = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_13, _toDisplayString(_ctx.t("remember me")), 1)
            ]),
            _createVNode(_component_router_link, {
              class: "-link -bold",
              to: { name: _ctx.RouterName.FORGOT_PASSWORD }
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t("forgotPassword")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createVNode(_component_Specifications),
          _createVNode("div", _hoisted_14, [
            _createTextVNode(_toDisplayString(_ctx.t("signup-title")) + " ", 1),
            _createVNode(_component_router_link, {
              class: "-link",
              to: { name: _ctx.RouterName.SIGNUP }
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t("signup")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode(_component_SelectLanguage)
          ]),
          (_ctx.isFetching)
            ? (_openBlock(), _createBlock(_component_ViewProgressSpinner, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
})